const GreenRed1 = [
    {id: "0", value: "綠轉紅"},    
    {id: "1", value: "紅轉綠"},   
  ];  
  
  export default GreenRed1